import { render, staticRenderFns } from "./right3.vue?vue&type=template&id=215cac2a&scoped=true&"
import script from "./right3.vue?vue&type=script&lang=js&"
export * from "./right3.vue?vue&type=script&lang=js&"
import style0 from "./right3.vue?vue&type=style&index=0&id=215cac2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215cac2a",
  null
  
)

export default component.exports